import type { FeatureResult } from '@growthbook/growthbook-react';
import { GrowthBook } from '@growthbook/growthbook-react';

import { getSandbox } from '../browser';

const getProjectToken = () => {
  const STAGING_CLIENT_KEY = 'sdk-VsyM0fa12ZtdRlXw';
  const PRODUCTION_CLIENT_KEY = 'sdk-DOA9wLpkQexDXKt5';

  return getSandbox() === 'production' ? PRODUCTION_CLIENT_KEY : STAGING_CLIENT_KEY;
};

const featureList = ['si-5703-si-notouch'];

export const growthBook = new (class GrowthBookService {
  private gb: GrowthBook = null!;
  private features: { [key: string]: FeatureResult['value'] } = {};

  public init() {
    this.gb = new GrowthBook({
      apiHost: 'https://cdn.growthbook.io',
      clientKey: getProjectToken(),
    });

    void this.gb.init({
      streaming: true,
    });
  }

  public getGrowthBook() {
    return this.gb;
  }

  private setFeatures = () => {
    this.features = featureList.reduce((acc, featureName) => {
      const value = this.gb.evalFeature(featureName)?.value as string | number | boolean;

      if (value === undefined || value === null) {
        return acc;
      }

      return {
        ...acc,
        [featureName]: value,
      };
    }, {});
  };

  public getFeatures = () => {
    return this.features;
  };

  public setUserProperties = ({ id, email }: { id: number; email: string }) => {
    void this.gb.setAttributes({ id, email });
    this.setFeatures();
  };
})();

export const initGrowthBook = () => {
  growthBook.init();

  return growthBook.getGrowthBook();
};
